import Ionicons from 'react-native-vector-icons/Ionicons'
import {View} from 'react-native-web'




const CheckBox =(props)=>{



 const iconName = props.isChecked ?
        "radio-button-on" : "radio-button-off";




  return(
    <View style={{position:'absolute', right:25, top:20}}>
    
     <Ionicons
            name={iconName}
            color={'#F9BA49'}
            size={18}
            style={{ marginLeft: 50 }}
            onPress={props.onPress1}
            onChangeValue={props.onChangeValue}
          />
         
    </View>

  )
}
  
         

          export {CheckBox}
        